import queryString from "query-string";

import { BUSINESS_RELATIONS } from "constants/actionTypes";
import { URLCreatorProps } from "actions/types";
import { serializeBusinessRelation } from "lib/serializers/businessRelations";
import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

function urlCreator(props: URLCreatorProps = {}): string {
  const { action, changesSince, id } = props;
  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/business-relations/", id, action),
    query: {
      changesSince,
    },
  });
}

export const BusinessRelationAction = offlineActionCreator(
  BUSINESS_RELATIONS,
  serializeBusinessRelation,
  urlCreator,
  false,
);
